module.exports = __webpack_public_path__ + "static/media/Unique.a49e5a1c.png";